'use client';
import { useLanguage } from '@/contexts/LanguageContext';

export default function QualitySection() {
  const { t } = useLanguage();

  const points = (t('quality.points') as unknown as string[]) || [];

  return (
    <section id="quality" className="py-24 px-6 md:px-12 bg-white">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-16 reveal">
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-foreground leading-tight">
            {t('quality.title')}
          </h2>
        </div>

        <div className="reveal bg-card border border-border rounded-3xl p-8 md:p-12 shadow-sm">
          <ul className="space-y-4">
            {points.map((point, idx) => (
              <li key={idx} className="flex items-start gap-3 text-base text-muted-foreground">
                <span className="text-primary font-bold flex-shrink-0 mt-0.5">✔</span>
                <span className="leading-relaxed">{point}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}

